import styled from "styled-components";
import DashboardBackground from '../../../../assets/images/Group3.svg';
import BannerBG from '../../../../assets/images/banner1BG.svg'

export const DashboardWrapper = styled.div`
    width: 100%;
    height: 100%;
    .audit {
        font-size: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 20px 0;
        user-select: none;
        svg {
          margin-left: 10px;
    
          path {
            fill: ${({ theme }) => theme.text1};
          }
    
          rect {
            fill: ${({ theme }) => theme.text1};
          }
        }
    }
   
    background-image: url(${DashboardBackground});
    background-repeat: no-repeat;
    background-size: cover;

   
    
`;

export const DashboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 2rem;
`;

export const DashboardTopSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    min-height: 680px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0 10%;
    text-style: bold;
    //box-shadow: 0px 6px 15px 2px rgb(118, 36, 142, 0.3);
    flex-wrap: wrap;
    ${({ theme }) => theme.mediaWidth.upToMedium`
       // padding: 2rem;
    `}
`;

export const DashboardBanner = styled.div`
    width: 80%;
    height: 160px;
    background-image: url(${BannerBG});
    background-repeat: no-repeat;
    border-radius: 0.5rem;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    animation: ease-in-out 0.2s;

    &:hover {
        cursor: pointer;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
    }
    ${({ theme }) => theme.mediaWidth.upToMedium`
       width: calc(100% - 2rem);
    `}
`;

export const DashboardSection = styled.section`
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 2rem 0;
    //border: 5px solid rgb(118, 36, 142, 0.3);
    border-radius: 2rem;
    padding: 2rem;
    background: #f0f2f760;

    > h1 {
        margin-top: 0;
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
        padding: 2rem 0;
        > h1 {
            padding-left: 1rem;
        }
    `}
`;

export const DashboardSectionTitle = styled.h1`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
`;

export const SectionList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    align-items: center;
    width: 100%;
    user-select: none;
    padding: 5px 0;
`;

export const SectionListItem = styled.div`
    margin: 0 1rem;
    display: flex;
    justify-content: center;
`;

export const SectionListWrapper = styled.div`
    height: 520px;
    width: 100%;
`;

export const NewsSectionWrapper = styled.div`
    height: 260px;
    width: 100%;
`;

export const TopSellerWrapper = styled.div`
    height: 245px;
    width: 100%;
`;

export const TopSellerItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    padding: 25px;

    &:hover {
        transform: scale(1.01);
        cursor: pointer;
    }
`;

export const TopSellerImage = styled.div`
    width: 120px;
    height: 120px;
    border-radius: 2rem;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    background: ${({ theme }) => theme.newBg3};
    border: 1px solid rebeccapurple;

    svg {
        width: 2rem;
        position: absolute;
        bottom: 5px;
        right: 5px;
        fill: rgb(32, 129, 226);
    }
`

export const TopSellerTitle = styled.span`
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 10px;
`;

export const TopSellerDescription = styled.span`
    font-size: 0.8rem;
    font-weight: bold;
    margin-bottom: 10px;
`;

export const PopularCollectionWrapper = styled.div`
    height: 450px;
    width: 100%;
`;

export const CarouselButton = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    &:hover {
        cursor: pointer;
        > svg {
            transform: translateY(-5px);
            transition: all 0.3s ease-in-out;
        }
    }
`;

export const CardCarouselWrapper = styled.div`
    height: 560px;
    width: 400px;
    position: relative;
    
    ${({ theme }) => theme.mediaWidth.upToSmall`
        overflow: hidden;
    `}
`;


export const DashboardCarouselContainer = styled.div`
    [class*="styles-module_item-container"],
    [class*="styles-module_item-provider"] {
        cursor: unset !important;
    }
`;

export const DashBoardNewsItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
`;

export const NewsImage = styled.img`
    position: relative;
    max-width: 350px;
    height: 200px;
    border-radius: 1rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
        transform: scale(1.02);
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
        max-width: 100%;
    `}
`;

export const NewsTitle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    padding: 0 0.5rem;
    font-weight: bold;
    width: 80%;
    height: 60px;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 1rem;

    .newDescription {
        font-size: 0.8rem;
        font-weight: normal;
        margin-top: 5px;
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;


export const DashboardFooter = styled.div`
    // display: grid;
    // grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    // grid-template-rows: 240px;
    // grid-row-gap: 2.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    padding: 2rem 10%;
    min-height: 250px;
    background: ${({ theme }) => theme.bg2};

    .footerSection {
        flex: 1;
        min-width: 200px;
        //height: 200px;
        margin: 1rem;
        display: flex;
        flex-direction: column;

        > * {
            margin-bottom: 1rem;
            font-size: 0.8rem;
        }

        > .footerSectionTitle {
            font-weight: bold;
            font-size: 1rem;
        }

        svg {
            margin-right: 0.5rem;
        }

        .footerLink {
            cursor: pointer;
            text-decoration: none;
            color: ${({ theme }) => theme.text1};
        }
    }
`;

export const FooterLogo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    > img {
        margin-right: 1rem;
    }
`;